import { render } from "./UiInputGroup.vue?vue&type=template&id=3ce4756e"
import script from "./UiInputGroup.vue?vue&type=script&lang=js"
export * from "./UiInputGroup.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__